import Html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import { Message } from 'element-ui'

export const outputPdf = async (element, filename = 'file.pdf', opts = {}) => {
  const baseOpts = {
    a4Width: 592.28,
    a4Height: 841.89,
    mode: 'download',
    marginBottom: 1,
  }

  opts = {
    ...baseOpts,
    ...opts,
  }
  const A4_WIDTH = opts.a4Width
  const A4_HEIGHT = opts.a4Height

  // unite different screen size
  element.ownerDocument.defaultView.devicePixelRatio = 2
  element.ownerDocument.defaultView.innerWidth = 1440

  const canvasOpts = {
    allowTaint: true,
    useCORS: true,
    scale: 2,
  }

  const pdf = new JsPDF('', 'pt', 'a4')
  const pageElements = opts.pageSelector
    ? Array.from(element.querySelectorAll(opts.pageSelector))
    : []

  if (pageElements.length) {
    for (let index = 0; index < pageElements.length; index++) {
      const canvas = await Html2Canvas(pageElements[index], canvasOpts)
      const imgWidth = A4_WIDTH
      const imgHeight = (A4_WIDTH / canvas.width) * canvas.height
      const pageData = canvas.toDataURL('image/jpeg', 1.0)

      if (index > 0) {
        pdf.addPage()
      }

      pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)

      // Release the rendered page before processing the next one
      canvas.width = 0
      canvas.height = 0
    }
  } else {
    const canvas = await Html2Canvas(element, canvasOpts)

    const contentWidth = canvas.width
    const contentHeight = canvas.height

    // PDF1ページに表示するHTMLページから生成されたcanvasの高さ
    const pageHeight = (contentWidth / A4_WIDTH) * A4_HEIGHT
    // PDFに未出力のHTMLページの高さ
    let leftHeight = contentHeight
    // ページのオフセット
    let position = 0
    // A4用紙のサイズ[595.28,841.89]とHTMLページから生成されたcanvas画像のPDF内での幅と高さ
    const imgWidth = A4_WIDTH
    const imgHeight = (A4_WIDTH / contentWidth) * contentHeight

    const pageData = canvas.toDataURL('image/jpeg', 1.0)

    // HTMLページの実際の高さと生成されるPDFページの高さ(841.89)を区別する
    // コンテンツがPDF1ページの表示範囲を超えない場合は改ページ不要
    if (leftHeight < pageHeight) {
      pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
    } else {
      while (leftHeight > opts.marginBottom) {
        pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
        leftHeight -= pageHeight
        position -= A4_HEIGHT
        // 空白ページが追加されないようにする
        if (leftHeight > opts.marginBottom) {
          pdf.addPage()
        }
      }
    }
  }

  if (opts.mode === 'preview') {
    const string = pdf.output('datauristring')
    const embed = "<embed width='100%' height='100%' src='" + string + "'/>"
    const x = window.open()
    x.document.open()
    x.document.write(embed)
    x.document.close()

    return
  }

  pdf.save(filename)
}

let idCounter = 0

export const genId = () => {
  return `id-${idCounter++}`
}

export default ({ $axios }, inject) => {
  inject('download', async (downloadUrl) => {
    const res = await $axios.get(downloadUrl, {
      responseType: 'blob',
      validateStatus: () => true,
    })

    if (res.status !== 200) {
      let msg = 'エラーが発生しました。'

      // Blob形式のエラーレスポンスからJSONのmessageを取得（HTML等の可能性があるためtry-catch）
      if (typeof res.data?.text === 'function') {
        try {
          const text = await res.data.text()
          if (text) {
            msg = JSON.parse(text)?.message || msg
          }
        } catch {}
      }

      // APIが返却するmessageを優先してトースト表示
      Message({ message: msg, type: 'info', customClass: 'toast' })
      return
    }

    const url = window.URL.createObjectURL(
      new Blob([res.data], { type: 'application/pdf' })
    )
    const link = document.createElement('a')
    const contentDisposition = res.headers['content-disposition']

    let filename = 'file.pdf'

    if (contentDisposition) {
      const regex = /filename\*?=['"]?(?:UTF-\d['"]*)?([^;\r\n"']*)['"]?;?/gi
      const matches = []
      let match

      while ((match = regex.exec(contentDisposition)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (match.index === regex.lastIndex) {
          regex.lastIndex++
        }

        // The result can be accessed through the `match` variable.
        matches.push(match)
      }

      // priority use utf8 filename, or use first default
      const filenameAry =
        matches.find((item) => {
          return /utf-8/i.test(item[0])
        }) || matches[0]

      filename = decodeURIComponent(filenameAry[1])
    }

    link.download = filename
    link.href = url
    link.target = '_blank'
    link.click()
  })
}
